import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import RootContextProvider from "./contexts/RootContextProvider";

// import UserProvider from "./contexts/UserProvider";
import  store ,{persistor} from './store'
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from 'react-redux'
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    <RootContextProvider>

      <App />
    </RootContextProvider>
    </PersistGate>
    </Provider>
  </React.StrictMode>
);
